import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_region_hdr_RowClass, bl_del_region_ext_RowClass } from '../../../../dbschema';

export class RegionDeliveryHeaderContainerModel extends BaseContainerModel {
    bl_del_region_hdr: bl_del_region_hdr_RowClass = new bl_del_region_hdr_RowClass();
    bl_del_region_ext: bl_del_region_ext_RowClass[] = [];
}